<template>
  <v-row class="kpi-row mx-0" :class="classRow" @click="clickRow(rowData)">
    <v-col class="kpi-label-wrapper pa-0">
      <div class="kpi-label d-flex align-center">
        <template v-if="!rowData['expand']">
          <a-period-compare :periods="periods()" dense></a-period-compare>
        </template>
        <template v-if="rowData['expand']">
          <v-avatar size="10" class="mr-1" :color="row_color"></v-avatar>
          <b>{{ row_title }}</b>
        </template>
        <template v-if="hasChilds">
          <v-spacer></v-spacer>
          <template v-if="row_active">
            <v-btn fab x-small depressed>
              <v-icon small>mdi-chevron-up</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn fab x-small depressed>
              <v-icon small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
        </template>
      </div>
    </v-col>
    <v-col class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col
          v-for="(col, index) of columns"
          :key="index"
          class="pa-0 d-flex kpi-cell kpi-cell-row align-center justify-center"
          @mouseover="kpi_hover = col.value"
          @mouseleave="kpi_hover = ''"
        >
          <template v-if="!rowData['expand']">
            <a-kpi :kpi="col.value" :value="rowData[col.value]" x_small>
              <template v-slot:right>
                <v-spacer></v-spacer>
                <a-increment
                  v-if="have_vs(col)"
                  :value="vs_values(col)"
                  :vs_value="rowData[col.value]"
                  :kpi="col.value"
                  :absolute="increment_mode === 'absolute'"
                  hide_tooltip
                >
                </a-increment>
              </template>
            </a-kpi>
          </template>
          <template v-else>
            <a-kpi :kpi="col.value" :value="rowData[col.value]" x_small></a-kpi>
          </template>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="pa-0 ma-0" cols="4">
      <v-row class="pa-0 ma-0">
        <v-col
          v-for="(col, index) of columns_no_vs"
          :key="index"
          class="pa-0 d-flex kpi-cell kpi-cell-row align-center justify-center"
          @mouseover="kpi_hover = col.value"
          @mouseleave="kpi_hover = ''"
        >
          <template v-if="!rowData['expand']">
            <a-kpi :kpi="col.value" :value="rowData[col.value]" x_small>
            </a-kpi>
          </template>
          <template v-else>
            <a-kpi :kpi="col.value" :value="rowData[col.value]" x_small></a-kpi>
          </template>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import * as Utils from "@/utils.js";
import aKpi from "@/components/rms_ui/aKpi.vue";
import aIncrement from "@/components/rms_ui/aIncrement.vue";
import aPeriodCompare from "@/components/rms_ui/aPeriodCompare.vue";

export default {
  name: "a-rms-strategy-weeks-detail-kpis-row",
  components: {
    aKpi,
    aIncrement,
    aPeriodCompare
  },
  props: {
    columns: Array,
    columns_no_vs: Array,
    rowData: Object,
    rowIndex: Number,
    increment_mode: {
      type: String,
      default: "percent"
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    row_active: false
  }),
  computed: {
    kpi_hover: {
      get() {
        return this.rms.strategy_kpi_table_hover;
      },
      set(value) {
        this.$store.dispatch("setRmsStrategyKpiTableHover", value);
      }
    },
    classRow() {
      let clas = "";
      if (!this.rowData.expand) {
        clas += " kpi-row-parent";
      }
      if (this.rowData.expand === "segment") {
        clas += " kpi-row-segment";
      } else if (this.rowData.expand === "channel") {
        clas += " kpi-row-channel";
      }
      if (this.dense) {
        clas += " dense";
      }
      return clas;
    },
    spot_parts() {
      return this.rowData.spot.split(" - ");
    },
    row_title() {
      if (this.rowData.expand === "segment") {
        return Utils.getDimensionName(this.segments, this.spot_parts[1]);
      } else if (this.rowData.expand === "channel") {
        return Utils.getDimensionName(
          this.channels,
          this.spot_parts[this.spot_parts.length - 1]
        );
      } else {
        return this.spot_parts[1];
      }
    },
    row_color() {
      if (this.rowData.expand === "segment") {
        return Utils.getDimensionColor(this.segments, this.spot_parts[1]);
      } else if (this.rowData.expand === "channel") {
        return Utils.getDimensionColor(
          this.channels,
          this.spot_parts[this.spot_parts.length - 1]
        );
      } else {
        return "grey";
      }
    },
    hasChilds() {
      if (
        this.rms.strategy_range_kpis_table.some(object => {
          if (object.spot.startsWith(this.rowData.spot + " - ")) return true;
        })
      ) {
        return true;
      }
      return false;
    },
    ...mapState({
      rms: state => state.rms,
      segments: state => state.segmentschannels.segments,
      channels: state => state.segmentschannels.segment_channels
    })
  },
  methods: {
    have_vs(col) {
      return col.value + "_vs" in this.rowData;
    },
    vs_values(col) {
      if (col.value + "_vs" in this.rowData) {
        return this.rowData[col.value + "_vs"];
      }
      return null;
    },
    periods() {
      if (!this.rowData["expand"]) {
        if (this.rowData["spot"] === "otb") {
          return [this.rowData["spot"]];
        } else {
          return [this.rowData["spot"], "otb"];
        }
      }
    },
    clickRow(v) {
      this.row_active = !this.row_active;
      this.$emit("clickRow", v, this.row_active);
    }
  }
};
</script>

<style lang="scss" scoped>
.kpi-row {
  &:hover {
    .kpi-label-wrapper {
      .kpi-label {
        border-right: 3px solid #2d6ece;
      }
    }
  }
  &.kpi-row-parent {
    .kpi-label-wrapper {
      .kpi-label {
        cursor: pointer;
      }
    }
  }
  &.kpi-row-segment {
    background-color: #f5fdff;
    .kpi-label-wrapper {
      .kpi-label {
        padding-left: 20px;
      }
    }
  }
  &.kpi-row-channel {
    background-color: #e6f1f4;
    .kpi-label-wrapper {
      .kpi-label {
        padding-left: 30px;
      }
    }
  }
  &.dense {
    .kpi-label-wrapper {
      .kpi-label {
        min-height: 40px;
      }
    }
    .kpi-cell {
      height: 40px;
    }
  }
  .kpi-label-wrapper {
    min-width: 200px;
    max-width: 200px;
    .kpi-label {
      border-right: 3px solid #ffffff;
      border-bottom: $borderType $borderColor;
      align-items: center;
      min-height: $minHeightColRow;
      gap: 5px;
      padding-left: 15px;
      font-size: 0.8rem;
      font-weight: 700;
      color: #555;
      width: 100%;
      padding-right: 5px;
    }
  }
  .kpi-cell {
    height: $minHeightColRow;
    text-align: center;
    border-bottom: $borderType $borderColor;
    border-left: $borderType $borderColorV;
    border-right: $borderType $borderColorV;
    line-height: 20px;
    font-size: 14px;
    width: 100%;

    &:hover {
      background-color: #f5fdff;
    }

    &.kpi-cell-row {
      span {
        &:first-child {
          font-weight: 700;
        }
        &:nth-child(2) {
          font-size: 12px;
          color: #555;
          margin-left: 5px;
        }
      }
    }

    .kpi-wrapper {
      &.periods {
        padding-bottom: 0;
      }
    }
  }
}
</style>
